module.exports = __webpack_public_path__ + "img/product_5.37006d4.webp";